<template>
  <div class="consultation-form-warp" v-show="isShowModel">
    <div class="modal">

      <div class="title">
        <h3>发起咨询</h3>
        <span @click="cancel">×</span>
      </div>

      <div class="content">
        <div class="form-item">
          <label for="name"><span class="red">*</span>问诊人：</label>
          <input type="text" id="name" v-model="info.username" placeholder="请输入问诊人姓名">
        </div>

        <div class="form-item">
          <label><span class="red">*</span>性别：</label>
          <select v-model="info.sex" name="sex">
            <option disabled value="">请选择</option>
            <option>男</option>
            <option>女</option>
          </select>
        </div>

        <div class="form-item">
          <label for="age"><span class="red">*</span>年龄：</label>
          <input type="text" id="age" v-model.number="info.age" placeholder="请输入年龄">
        </div>

        <div class="form-item">
          <label for="phone"><span class="red">*</span>手机号：</label>
          <input type="text" id="phone" v-model.number="info.phone" placeholder="请输入联系人手机号">
        </div>

        <div class="form-item vertical-top">
          <label for="decs"><span class="red">*</span>病情描述：</label>
          <textarea id="decs" v-model="info.description" cols="30" rows="10"
                    placeholder="请详细描述您的病情，便于医生更准确的分析（10字以上）"></textarea>
        </div>

        <div class="form-item vertical-top">
          <label><span class="red"></span>病情照片：</label>
          <div style="flex: 1;flex-wrap: wrap;margin-right: 96px">
            <UploadImg @uploadImg="getImgUrl"></UploadImg>
          </div>
        </div>

        <p class="tip">您可上传与病情相关的图片(包括检查检验单、CT、患处、药品等)。图片仅自己和医生可见。最多可以上传9张图片。</p>

        <div class="submit-warp">
          <button class="link-button submit-button" @click="submit">提交并付款</button>
          <button class="link-button cancel-button" @click="cancel">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UploadImg from '../components/UploadImg'

  export default {
    name: "ConsultationForm",
    components: {
      UploadImg
    },
    props: {
      isShowModel: {
        default: false,
      }
    },
    data() {
      return {
        info: {
          username: '',
          sex: '',
          description: '',
          age: null,
          phone: null,
          images: '',
        }
      }
    },
    methods: {
      submit() {
        let {username, sex, description, age, phone,} = this.info;
        if (!username) {
          alert('请填写问诊人姓名');
          return
        }
        if (!sex) {
          alert('请选择性别');
          return
        }
        if (!age) {
          alert('请输入年龄');
          return
        }
        if (!phone || !(/^1\d{10}/.test(phone + ''))) {
          alert('请填写正确的手机号');
          return
        }

        if (!description||description.length<10) {
          alert('请填写您的病情，10个字以上');
          return
        }
        this.$emit('sendInfo', this.info);
      },
      cancel() {
        this.$emit('showModel', false)
      },
      getImgUrl(val) {
        this.info.images = val;
      },

    }
  }
</script>

<style scoped lang="less">
  .consultation-form-warp {
    position: fixed;
    z-index: 888;
    overflow: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(55, 55, 55, .6);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .modal {
      width: 640px;
      background-color: #fff;
      .title {
        height: 42px;
        line-height: 42px;
        display: flex;
        justify-content: space-between;
        color: #fff;
        background-color: #34404D;
        h3 {
          font-size: 16px;
          margin-left: 24px;
        }
        span {
          margin-right: 16px;
        }
      }

      .content {
        padding: 40px 0;
        font-size: 14px;
        color: rgba(0, 0, 0, .85);

        .form-item {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .red {
            color: red;
            margin-right: 8px;
          }
          label {
            width: 146px;
            text-align: right;
            margin-right: 8px;
          }

          input, select {
            width: 256px;
            height: 32px;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            border: 1px solid rgba(0, 0, 0, 0.15);
            padding-left: 12px;
            outline: none;
            background: #fff;
          }
          select {
            width: 270px;
            color: rgba(0, 0, 0, 0.65);
          }
          textarea {
            width: 384px;
            height: 98px;
            resize: none;
            border: 1px solid rgba(0, 0, 0, .15);
            outline: none;
            text-indent: 1em;
            line-height: 22px;
            font-size: 14px;
          }

          ul {
            display: flex;
            margin-left: 8px;
            li {
              display: flex;
              align-items: center;
              margin-right: 32px;
              span {
                width: 14px;
                height: 14px;
                border: 1px solid rgba(0, 0, 0, 0.15);
                border-radius: 50%;
                margin-right: 8px;
                color: rgba(0, 0, 0, 0.85);
              }
              .active {
                border-color: #108EE9;
              }
            }

          }

          .agree-warp {
            margin-left: 204px;
            margin-top: 26px;
            display: flex;
            align-items: center;
            i {
              width: 14px;
              height: 14px;
              border: 1px solid rgba(0, 0, 0, 0.15);
              border-radius: 2px;
              margin-right: 8px;
              color: #fff;
              font-size: 10px;
              text-align: center;
              font-style: normal;
            }
            .read {
              color: #108EE9;
            }
            span {
              color: #108EE9;
              &:hover {
                cursor: pointer;
              }
            }
          }
        }
        .vertical-top {
          align-items: flex-start;
        }
        .tip {
          color: rgba(0, 0, 0, 0.35);
          line-height: 22px;
          width: 384px;
          margin: 16px 102px 32px 154px;
        }
        .submit-warp {
          margin-left: 154px;
          display: flex;
          align-items: center;
          margin-top: 32px;
          button {
            margin-right: 16px;
          }
        }
      }
    }
  }
</style>